import { userConstants } from "../constants";
import Cookies from "js-cookie";

const token = sessionStorage.getItem("token");
const initialState = token
  ? {
      loggedIn: true,
      user: jwtDecoder(token.replace("Bearer ", "")),
      token,
      error: null,
    }
  : {
      loggedIn: false,
      user: null,
      token: null,
      error: null,
      loading: false,
    };

export function authentication(state = initialState, action) {
  switch (action.type) {
    // ^ LOGIN ----------------------------------------------------------------------
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        error: null,
      };

    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        loggingIn: false,
        user: action.payload.user,
        token: action.payload.token,
        error: null,
      };

    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        error: "Nope",
      };

    // ^ UPDATETOKEN ----------------------------------------------------------------------

    case userConstants.UPDATETOKEN_REQUEST:
      return {
        ...state,
      };

    case userConstants.UPDATETOKEN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        user: action.payload.user,
        token: action.payload.token,
        error: null,
      };

    case userConstants.UPDATETOKEN_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    // ^ UPDATETCHECKMAGICLINK ----------------------------------------------------------------------

    case userConstants.CHECKMAGICLINK_REQUEST:
      return {
        ...state,
      };

    case userConstants.CHECKMAGICLINK_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        user: action.payload.user,
        token: action.payload.token,
        error: null,
      };

    case userConstants.CHECKMAGICLINK_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case userConstants.REGISTER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    // ^ LOGOUT ----------------------------------------------------------------------

    case userConstants.LOGOUT:
      return {
        loggedIn: false,
        user: null,
        token: null,
        sites: [],
        error: null,
      };

    // ^ DEFAULT ----------------------------------------------------------------------

    default:
      return { ...state };
  }
}

function jwtDecoder(token) {
  if (token != null && token !== undefined && token != "null") {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    var decoded = JSON.parse(atob(base64));

    return decoded;
  } else {
    return null;
  }
}
